import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Parses url search string (`my.site?param1=value1`) into js object
 *
 * @returns `URLSearchParams` object */
export const useURLQueryParams = (): URLSearchParams => {
  const { search } = useLocation();

  const queryParams = useMemo(() => new URLSearchParams(search), [search]);

  return queryParams;
};
